import { DSIcon } from '../common/atoms';
import React, { Component } from 'react'
import { Row, Tabs, Col, Card, Spin, Tag, Tooltip } from 'antd'
import { MaleTestImage, FemaleTestImage } from '../../assets/images'
import axios from 'axios'
import { analyticsApi, utilizationApi } from '../../services'
import { handleAppError } from '../handlers'
import ContractsManager from '../../managers/ContractsManager'
import { Tabbar } from '../common/molecules'
import { Breadcrumb } from '../common/atoms'
import { TEST_COMPONENTS_INFO, TEST_RESULTS_KEY_MAP } from '../../constants/testResults'
import { AppStateContext } from '../../utils/contexts'
const TabPane = Tabs.TabPane
let token = ''
const TEST_BAR_COLORS = {
  default: '#F3F4F6',
  affected: '#E8432C',
  normal: '#14866D',
  warning: '#D97706',
  muted: '#6B7280',
  ink: '#0F1115',
}

class TestResults extends Component {
  static contextType = AppStateContext

  constructor(props) {
      super(props)
      this.state = {
        loading: false,
        data: {},
        testResults: {},
        tabLoading: false,
        contractId :null
      }
  }

  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data, 'Health-checks')
        this.setState({ metricObj: contractObj, contractId: contractObj.formattedData[0].contract_id, startDate: contractObj.formattedData[0].start_date, endDate: contractObj.formattedData[0].end_date })
      },
      (err) => {
        handleAppError(err)
      }
    )
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source()
    const init = analyticsApi.getTestResultsAnalytics({contractId, startDate, endDate, companyId: this.context.companyId, cancelToken: token.token})
    const lipids = analyticsApi.getLipidsTestResults({contractId, startDate, endDate, companyId: this.context.companyId, cancelToken: token.token})

    Promise.all([init,lipids])
    .then((responses) => {
      responses = responses.map((response) => response.data)
      const data = responses[0]
      const testResults = {
        'Lipids': responses[1]
      }

      this.setState({ data, testResults, loading: false, tabLoading : false })
    })
    .catch((err)=>{
      handleAppError(err)
      this.setState({ loading: false, tabLoading : false })
    })
  }

  fetchTestResultData = async (key) => {
    key = parseInt(key, 10)
    const testResultName = TEST_RESULTS_KEY_MAP[key]
    if(!!this.state.testResults[testResultName]) return

    token = axios.CancelToken.source()
    const contractId = this.state.contractId
    const startDate = this.state.startDate
    const endDate = this.state.endDate
    let response = null
    switch(key) {
      case 2:
        response = await analyticsApi.getKidneyTestResults({contractId, startDate, endDate, companyId: this.context.companyId, cancelToken: token.token})
        break
      case 3:
        response = await analyticsApi.getLiverTestResults({contractId, startDate, endDate, companyId: this.context.companyId, cancelToken: token.token})
        break
      case 4:
        response = await analyticsApi.getUrinExamTestResults({contractId, startDate, endDate, companyId: this.context.companyId, cancelToken: token.token})
        break
      case 5:
        response = await analyticsApi.getCbcTestResults({contractId, startDate, endDate, companyId: this.context.companyId, cancelToken: token.token})
        break
      case 6:
        response = await analyticsApi.getThyroidTestResults({contractId, startDate, endDate, companyId: this.context.companyId, cancelToken: token.token})
        break
      case 7:
        response = await analyticsApi.getDiabetesTestResults({contractId, startDate, endDate, companyId: this.context.companyId, cancelToken: token.token})
        break
      case 8:
        response = await analyticsApi.getBpTestResults({contractId, startDate, endDate, companyId: this.context.companyId, cancelToken: token.token})
        break
    }

    if(!!response) {
      this.setState(prevState => ({ testResults: {...prevState.testResults, [testResultName]: response.data} }))
    }
  }

  componentDidMount () {
    this.fetchContractDetails()
    this.setState({ loading: true })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.contractId && prevState.contractId !== this.state.contractId) {
      token && token.cancel()
      this.fetchCompleteData(this.state.contractId, this.state.startDate, this.state.endDate)
    }
  }

  changeContractId = (contract) => {
    const { contractId }  = this.state
    const { contract_id, start_date, end_date } = contract
    if (contract_id && contractId !== contract_id) {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        tabLoading: true,
      })
    } else if (contract.text === 'Overall') {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        tabLoading: true,
      })
    }
  }

  getColor(value){
    let color = TEST_BAR_COLORS.default
    if (value === 'Affected') {
      color = TEST_BAR_COLORS.affected
    }else if(value === 'NotAffected'){
      color = TEST_BAR_COLORS.normal
    }else if(value === 'Yellow') {
      color = TEST_BAR_COLORS.warning
    }
    return color
  }

  renderCardName(value){
    return(
      <h2 className="main-numbers">{value}</h2>
    )
  }

  renderPopoverContent(gender,age,total,percentage,color){
    let affected_type = `${color === TEST_BAR_COLORS.affected ?  'are affected' : 'are normal'} out of those who took the test`

    return(
      <div>
        <Row type="flex" justify="start">
          <h5 style={{color: TEST_BAR_COLORS.muted, fontFamily: 'JetBrains Mono', fontSize: 11}}>Age Group: {age}</h5>
        </Row>
        <Row type="flex" justify="start" style={{marginLeft: '-8px', marginRight: '-15px'}}>
          <h5 style={{color: TEST_BAR_COLORS.muted, fontSize: 12}}>&nbsp; <span className="semibold" style={{color: color, fontFamily: 'JetBrains Mono'}}>{percentage}</span> {gender} {affected_type}</h5>
        </Row>
      </div>
    )
  }

  renderDetailSvg(gender,age,search_key,id1,id2,id3,id4){
    if(search_key["Total"] > 5){
      const affectedPercent = search_key["Affected"]*100/search_key["Total"]
      const notAffectedPercent = search_key["Not Affected"]*100/search_key["Total"]
      return(
        <div>
          <h5 style={{color: TEST_BAR_COLORS.muted, marginBottom: 4, fontSize: 12}}><span className="semibold" style={{color: TEST_BAR_COLORS.ink, fontFamily: 'JetBrains Mono'}}>{affectedPercent.toFixed(0) + '%'}</span> are affected</h5>
          <a>
            <svg height="24" width="100%">
              <rect x="0" y="6" width="100%" height="12" rx="6" ry="6" style={{fill: this.getColor("Default")}}/>
              <Tooltip overlayClassName='test-results-percentage-tooltip' title={this.renderPopoverContent(gender,age,search_key["Total"],affectedPercent.toFixed(0) + '%',TEST_BAR_COLORS.affected)}>
                <rect id={id1} x="0" y="6" width={affectedPercent + '%'} height="12" rx="6" ry="6" style={{fill: this.getColor("Affected")}} />
              </Tooltip>
              <Tooltip overlayClassName='test-results-percentage-tooltip' title={this.renderPopoverContent(gender,age,search_key["Total"],notAffectedPercent.toFixed(0) + '%',TEST_BAR_COLORS.normal)}>
                <rect id={id2} x={affectedPercent + '%'} y="6" width={notAffectedPercent + '%'} height="12" rx="6" ry="6" style={{fill: this.getColor("NotAffected")}} />
              </Tooltip>
              <rect id={id3} x="0" y="20" width={affectedPercent + '%'} height="3" rx="2" ry="2" />
              <rect id={id4} x={affectedPercent + '%'} y="20" width={notAffectedPercent + '%'} height="3" rx="2" ry="2"/>
            </svg>
          </a>
        </div>
      )
    }
    else if(isNaN(parseInt(search_key["Affected"]*100/search_key["Total"]).toFixed(0))){
      return(
        <div>
          <h5 style={{color: TEST_BAR_COLORS.muted, marginBottom: 4, fontSize: 12}}>minimum 6 {gender} employees test required to show data</h5>
          <svg height="24" width="100%">
            <rect x="0" y="6" width="100%" height="12" rx="6" ry="6" style={{fill: this.getColor("Default")}}/>
          </svg>
        </div>
      )
    }
    else{
      return(
        <div>
          <h5 style={{color: TEST_BAR_COLORS.muted, marginBottom: 4, fontSize: 12}}>minimum 6 {gender} employees test required to show data</h5>
          <svg height="24" width="100%">
            <rect x="0" y="6" width="100%" height="12" rx="6" ry="6" style={{fill: this.getColor("Default")}}/>
          </svg>
        </div>
      )
    }
  }

  renderDetailTestAnalysis(key,record){
    let male_less_than_25 = record["gender and age"]["male"]["<= 25"]
    let male_26_to_30 = record["gender and age"]["male"]["26-30"]
    let male_31_to_35 = record["gender and age"]["male"]["31-35"]
    let male_36_to_40 = record["gender and age"]["male"]["36-40"]
    let male_greater_than_40 = record["gender and age"]["male"]["> 40"]
    let female_less_than_25 = record["gender and age"]["female"]["<= 25"]
    let female_26_to_30 = record["gender and age"]["female"]["26-30"]
    let female_31_to_35 = record["gender and age"]["female"]["31-35"]
    let female_36_to_40 = record["gender and age"]["female"]["36-40"]
    let female_greater_than_40 = record["gender and age"]["female"]["> 40"]

    return(
      <div>
        <Row>
          <Col span={12}>
            <h3 className="font-semibold">{key}</h3>
            <h5 style={{color: '#6B7280'}}>{TEST_COMPONENTS_INFO[key]}</h5>
          </Col>
        </Row>
        <Row style={{marginTop: 60}}>
          <Col span={5}>
            <Row type="flex" justify="start">
              <img src={MaleTestImage}/>
              <h4 className="semibold" style={{color: '#6B7280',marginTop: 10,marginLeft: 5}}>MALE</h4>
            </Row>
          </Col>
          <Col span={5}>
          </Col>
          <Col span={4}>
          </Col>
          <Col span={5}>
            <Row type="flex" justify="start">
              <img src={FemaleTestImage}/>
              <h4 className="semibold" style={{color: '#6B7280',marginTop: 10,marginLeft: 5}}>FEMALE</h4>
            </Row>
          </Col>
        </Row>
        <Row style={{marginTop: 30}}>
          <Col span={10} style={{paddingLeft: 5}}>
            {this.renderDetailSvg("male","<=25",male_less_than_25,"m25_affected","m25_not_affected","m25_affected_hover","m25_not_affected_hover")}
          </Col>
          <Col span={4} style={{marginTop: 3}}>
            <Row type="flex" justify="center">
              <Tag className="age-rectangle1"> &lt;=25 </Tag>
            </Row>
          </Col>
          <Col span={10} style={{paddingLeft: 5}}>
            {this.renderDetailSvg("female","<=25",female_less_than_25,"f25_affected","f25_not_affected","f25_affected_hover","f25_not_affected_hover")}
          </Col>
        </Row>
        <Row style={{marginTop: 30}}>
          <Col span={10} style={{paddingLeft: 5}}>
            {this.renderDetailSvg("male","26-30",male_26_to_30,"m26_to_30_affected","m26_to_30_not_affected","m26_to_30_affected_hover","m26_to_30_not_affected_hover")}
          </Col>
          <Col span={4} style={{marginTop: 3}}>
            <Row type="flex" justify="center">
              <Tag className="age-rectangle-2"> 26-30 </Tag>
            </Row>
          </Col>
          <Col span={10} style={{paddingLeft: 5}}>
            {this.renderDetailSvg("female","26-30",female_26_to_30,"f26_to_30_affected","f26_to_30_not_affected","f26_to_30_affected_hover","f26_to_30_not_affected_hover")}
          </Col>
        </Row>
        <Row style={{marginTop: 30}}>
          <Col span={10} style={{paddingLeft: 5}}>
            {this.renderDetailSvg("male","31-35",male_31_to_35,"m31_to_35_affected","m31_to_35_not_affected","m31_to_35_affected_hover","m31_to_35_not_affected_hover")}
          </Col>
          <Col span={4} style={{marginTop: 3}}>
            <Row type="flex" justify="center">
              <Tag className="age-rectangle-2"> 31-35 </Tag>
            </Row>
          </Col>
          <Col span={10} style={{paddingLeft: 5}}>
            {this.renderDetailSvg("female","31-35",female_31_to_35,"f31_to_35_affected","f31_to_35_not_affected","f31_to_35_affected_hover","f31_to_35_not_affected_hover")}
          </Col>
        </Row>
        <Row style={{marginTop: 30}}>
          <Col span={10} style={{paddingLeft: 5}}>
            {this.renderDetailSvg("male","36-40",male_36_to_40,"m36_to_40_affected","m36_to_40_not_affected","m36_to_40_affected_hover","m36_to_40_not_affected_hover")}
          </Col>
          <Col span={4} style={{marginTop: 3}}>
            <Row type="flex" justify="center">
              <Tag className="age-rectangle-2"> 36-40 </Tag>
            </Row>
          </Col>
          <Col span={10} style={{paddingLeft: 5}}>
            {this.renderDetailSvg("female","36-40",female_36_to_40,"f36_to_40_affected","f36_to_40_not_affected","f36_to_40_affected_hover","f36_to_40_not_affected_hover")}
          </Col>
        </Row>
        <Row style={{marginTop: 30}}>
          <Col span={10} style={{paddingLeft: 5}}>
            {this.renderDetailSvg("male",">=41",male_greater_than_40,"m40_affected","m40_not_affected","m40_affected_hover","m40_not_affected_hover")}
          </Col>
          <Col span={4} style={{marginTop: 3}}>
            <Row type="flex" justify="center">
              <Tag className="age-rectangle1"> &gt;=41 </Tag>
            </Row>
          </Col>
          <Col span={10} style={{paddingLeft: 5}}>
            {this.renderDetailSvg("female",">=41",female_greater_than_40,"f40_affected","f40_not_affected","f40_affected_hover","f40_not_affected_hover")}
          </Col>
        </Row>
      </div>
    )
  }

  renderFixedTestAnalysis(key,text){
    let that = this
    let tab_keys = Object.keys(that.state.testResults[key])
    return(
      <div>
        <Row>
          <Col span={24}>
            <Row type="flex" justify="start" style={{marginLeft: 0, marginTop: 16, marginBottom: 12 }}>
              <h5 className="sub-title mb-0">DETAILED {text} ANALYSIS</h5>
            </Row>
          </Col>
        </Row>
        <Card className="health-check-utilization-card" style={{marginBottom: 10, marginTop: 0}}>
          <Tabs defaultActiveKey="0">
            {tab_keys.map((x, index) => (
              <TabPane tab={`${x}`} key={index}>
                {this.renderDetailTestAnalysis(x,that.state.testResults[key][x])}
              </TabPane>
              ))}
          </Tabs>
        </Card>
      </div>
    )
  }

  renderEmptyStateTestAnalysis(text){
    return(
      <div>
        <Row>
          <Col span={24}>
            <Row type="flex" justify="start" style={{marginLeft: 0, marginTop: 16, marginBottom: 12}}>
              <h5 className="sub-title mb-0">DETAILED {text} ANALYSIS</h5>
            </Row>
          </Col>
        </Row>
        <Card className="health-check-utilization-card" style={{marginBottom: 10, marginTop: 0}}>
          <Row>
            <Col span={12} style={{backgroundColor: '#fff3f3',borderLeft: '6px solid #ffc8c8'}}>
              <Row type="flex" justify="start" style={{marginTop: 12,marginLeft: 24}}>
                <h4 className="font-semibold">The selected test is not included in your package</h4>
              </Row>
              <Row type="flex" justify="start" style={{marginTop: 3,marginLeft: 24,marginBottom: 6}}>
                <h5 className="zero-state-body-text" style={{marginTop: '-10',paddingRight: 10}}>Reach out to your customer success manager <span className="semibold" style={{color: '#2563EB'}}>{sessionStorage.getItem('hr_contact_email')}</span> to include this test into your package</h5>
              </Row>
            </Col>
          </Row>
        </Card>
      </div>
    )
  }

  renderTestAnalysis(key,text){
    let that = this
    if(that.state.testResults[key] === undefined){
      return(
        <div>
          {this.renderEmptyStateTestAnalysis(text)}
        </div>
      )
    }
    else{
      return(
        <div>
          {this.renderFixedTestAnalysis(key,text)}
        </div>
      )
    }

  }

  getTheText = (id, data) =>{
    let tab = data.find(item => item.contract_id === id)
    return tab.text ;
  }

  componentWillUnmount() {
    token && token.cancel()
  }

  render () {
    let that = this
    const formattedData = that.state.metricObj?.formattedData
    return(
      <div>
        {(that.state.loading || Object.keys(that.state.data).length === 0 )?
        <div className="spiner">
          <Spin size="large"/>
        </div>
        :
        <div>
        <Row>
          <div className='flex flex-col'>
            <Breadcrumb
              list={[
                { text: 'Analytics', link: '#' },
                { text: 'Health checks', link: '/test-results' },
              ]}
            />
            <h2 className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl mb-0 mt-1.5'>Health checks</h2>
            <p className='text-gray-500 leading-4 text-sm mt-2 mb-0'>Detailed insights on test results for active employees</p>
          </div>
        </Row>
        <Row>
          <Tabbar
            list={formattedData}
            loading={true}
            classes='mt-3'
            currentPage={this.getTheText(this.state.contractId, formattedData)}
            setContract={this.changeContractId}
          />
        </Row>
        { that.state.tabLoading ?
            <div className="spiner">
              <Spin size="large"/>
            </div>
          :
            <div>
              <Row>
                <Col span={12}>
                  <Row type="flex" justify="start" style={{marginLeft: 0, marginTop: 32}}>
                    <h4 className="sub-heading-title" style={{color: '#6B7280', marginBottom: 12, marginLeft: 0, marginTop: 7}}>TEST RESULTS BY CATEGORY</h4>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Tabs defaultActiveKey="1"  onChange={this.fetchTestResultData}>
                    {
                      Object.entries(TEST_RESULTS_KEY_MAP).map(([key, value]) => {
                        return (
                          <TabPane tab={value} key={key}>
                            {this.renderTestAnalysis(value)}
                          </TabPane>
                        )
                      })
                    }
                  </Tabs>
                </Col>
              </Row>
              <Row type="flex" justify="start">
                <h5 className="health-check-note items-center"><DSIcon name='info' className='mr-1 inline-block align-[-2px] text-amber-700' size={14} />&nbsp;Active Employees who haven’t provided D.O.B or Gender : <span className="semibold">{parseInt(that.state.data.no_age_or_gender).toFixed(0)}</span></h5>
              </Row>
            </div>
          }
        </div>
      }
      </div>
    )
  }
}

export default TestResults
